import DashboardScaffold from "ui/common/components/layout/DashboardScaffold/DashboardScaffold";
import PartnerPointOfSell from "../container/PartnerPointOfSell/PartnerPointOfSell";

function PartnerPointOfSellPage() {
    return (
        <DashboardScaffold>
            {/* skipcq: JS-0424 */}
            <></>
            <PartnerPointOfSell />
        </DashboardScaffold>
    );
}

export default PartnerPointOfSellPage;
